import { useEffect, RefObject } from 'react';

export function useTwoLineEllipsis(
  ref: RefObject<HTMLElement>,
  lineHeight: number = 20,
  lines: number = 2
): void {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const maxHeight = lineHeight * lines;
    const fullText = element.innerText.trim();
    const words = fullText.split(' ');

    let truncated = '';
    element.innerText = '';

    for (let i = 0; i < words.length; i++) {
      const testText = truncated + words[i] + ' ';
      element.innerText = testText;

      if (element.scrollHeight > maxHeight) {
        element.innerText = truncated.trim() + '...';
        break;
      }

      truncated = testText;
    }
  }, [ref, lineHeight, lines]);
}
